import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { t } from '@lingui/macro';
import { AssignedListItemWrapper } from './assigned-list-item.styled';
import { CheckboxWrapper } from '../assigned-list/assigned-list.styled';
import Checkbox from '../../../../checkbox';
import { CHECKED, UNCHECKED, DISABLED } from '../../../../checkbox/constants';
import InstructionHubFeedback from '../../../../instruction-hub-feedback';
import { INSTRUCTION_HUB_MESSAGE_CONTEXTS } from '../../../../instruction-hub-message';
import { isDefined } from '../../../../../helpers/utils';

const AssignedListItem = ({
  i18n,
  isSelected,
  index,
  onCheckboxChange,
  assignedListItem,
  isInstructionHubBlocked
}) => {
  function status() {
    if (isInstructionHubBlocked) {
      return i18n._(t('assignedTab.instructionHub')`Instruction Hub`);
    }

    switch (assignedListItem.assignStatus) {
      case 0:
        return 'Coming up';
      case 1:
        return 'In progress';
      case 2:
        return 'Overdue';
      case 3:
        return 'Not attempted';
      default:
        break;
    }
    return false;
  }

  const selectedState = isSelected ? CHECKED : UNCHECKED;

  const dueDate = isDefined(assignedListItem.dueDate)
    ? moment(assignedListItem.dueDate).format('DD-MMM-YYYY')
    : i18n._(t('assignedTab.noDueDate')`No due date`);

  return (
    <AssignedListItemWrapper>
      <CheckboxWrapper>
        <InstructionHubFeedback
          i18n={i18n}
          context={INSTRUCTION_HUB_MESSAGE_CONTEXTS.CELL}
          isBlocked={isInstructionHubBlocked}
        >
          <Checkbox
            checkboxHandler={onCheckboxChange}
            state={isInstructionHubBlocked ? DISABLED : selectedState}
            id={index}
          />
        </InstructionHubFeedback>
      </CheckboxWrapper>
      <div
        title={assignedListItem.activityName}
        data-testid="assigned-activity-name"
      >
        {assignedListItem.activityName}
      </div>
      <div
        title={assignedListItem.assignStatus}
        data-testid="assigned-activity-status"
      >
        {status()}
      </div>
      <div
        title={assignedListItem.startDate}
        data-testid="assigned-activity-startdate"
      >
        {moment(assignedListItem.startDate).format('DD-MMM-YYYY')}
      </div>
      <div
        title={assignedListItem.dueDate}
        data-testid="assigned-activity-duedate"
      >
        {dueDate}
      </div>
    </AssignedListItemWrapper>
  );
};

AssignedListItem.propTypes = {
  i18n: PropTypes.object,
  isSelected: PropTypes.bool,
  index: PropTypes.number.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  assignedListItem: PropTypes.object,
  isInstructionHubBlocked: PropTypes.bool
};

export default AssignedListItem;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-assigned/assigned-list-item/assigned-list-item.js